import { render, staticRenderFns } from "./spinner-dynamic.vue?vue&type=template&id=47716a34&scoped=true&functional=true"
import script from "./spinner-dynamic.vue?vue&type=script&lang=js"
export * from "./spinner-dynamic.vue?vue&type=script&lang=js"
import style0 from "./spinner-dynamic.vue?vue&type=style&index=0&id=47716a34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "47716a34",
  null
  
)

export default component.exports